import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { AdminConfirmProvider } from '@/admin/shared/AdminConfirmProvider';
import { UserImportSteps } from './UserImportSteps';
import { UserImportUpload } from './UserImportUpload';
import { UserImportReview } from './UserImportReview';

/**
 * Import users from a spreadsheet, at /admin/import/users (the side nav's Import > Users, the
 * users list's Import button, or the import history's Import menu). First the steps, the
 * template download and the upload; once the file is read, its rows to review and fix
 * (UserImportReview). Once the import starts the admin goes to its report in the import
 * history (/admin/imports/:importId).
 */
export const UserImportPage = () => {
	// The file being reviewed: { storagePath, fileName, rows }
	const [file, setFile] = useState(null);

	return (
		<AdminConfirmProvider>
			{file ? (
				<UserImportReview file={file} onCancel={() => setFile(null)} />
			) : (
				<Stack spacing={2}>
					<UserImportSteps />
					<UserImportUpload onRead={setFile} />
				</Stack>
			)}
		</AdminConfirmProvider>
	);
};

UserImportPage.displayName = 'UserImportPage';
